import { createViewConfig } from '@sail/engine';
export const PopoverConfig = createViewConfig({
    props: {},
    name: 'Popover',
    defaults: {
        placement: 'bottom',
        dismissible: true,
        showOnPress: false,
        showOnFocus: false,
        showOnHover: false
    }
});

//# sourceMappingURL=PopoverConfig.js.map